<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_39",
      next: "P_41",
      topic: "Estás en: Taller ¿Qué es crédito? / ¡Quiero conocer el tipo de crédito ideal para mí!",
      progress: false
    };
  },
  methods: {

  }
};
</script>

<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md10, lg9)
          v-card(flat, text-xs-center)
            breadcrumb(:back='last') {{topic}}
            v-card-text.text-xs-center.label16tt.withDivider(style='color:#F7893B')
              | ESCENARIO 4
            v-layout(row, wrap, justify-start, py-4)
              v-flex.ma-0.pa-0(xs12, md6)
                v-card.pa-5(flat, height='100%', color='secondary')
                  v-card-text.parrafoDestacadoW.pl-5.py-3.mt-3
                    | José se cambió de trabajo hace un par de meses y ha notado que pierde mucho tiempo en trasladarse en transporte público. 
                  v-card-text.parrafoDestacadoW.pl-5.py-3.mt-3
                    b Ha considerado adquirir un auto de agencia semi nuevo 
                    |  para poder ir a su trabajo, pero no lo ha hecho porque aún no reúne la cantidad necesaria para el auto que quiere.
              v-flex.ma-0.pa-0(xs12, md6)
                v-card(flat, text-xs-start)
                  v-img(height='600px', :src='require("@/assets/TCC-L7-Pagina5 A.png")')
            v-layout(row, justify-center)
              v-btn.btn(justify-space-between, type='button', color='accent', @click.prevent="nextPage(next)")

                | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>


